import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa,BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { SalesCreditNoteImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/sales-credit-note-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class SalesCreditNoteImportFileHelperService extends BaseApiTemplateService<SalesCreditNoteImportFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/helper/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }

  async updateBackOfficeEp(containers: any[], visa: ApiVisa): Promise<any> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/helper/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/helper/update/backoffice-ep';
    }
    
    const headers = this.getHttpHeader(visa);
    
    return this.httpClient.put(url, containers, headers).toPromise();
  }

    async resubmitBackOfficeEp(containers: any[], visa: ApiVisa, file_hdr_guid: string): Promise<any> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/resubmit/backoffice-ep/' + file_hdr_guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-credit-note/import-file-hdr/resubmit/backoffice-ep/' + file_hdr_guid;
    }
    
    const headers = this.getHttpHeader(visa);
    
    return this.httpClient.post(url, containers, headers).toPromise();
  }




}